// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='EditMetadataRow'] {\r\n    padding: 16px 24px;\r\n}", ""]);
// Exports
module.exports = exports;
